import { Box } from '@mui/material'
import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  boxContent: {
    padding: `clamp(${theme.spacing(1)}, ${theme?.custom?.app.scaleFactor.default}, ${theme.spacing(2)})`,
  },
}))

const BoxContent = (props) => {
  const classes = useStyles()

  return <Box className={classes.boxContent} {...props} />
}

BoxContent.propTypes = {
  children: PropTypes.node,
}

export default BoxContent
